import React from 'react';
import { Link } from 'react-router';
import CrimsonLogo from '../../components/CrimsonLogo';
import { C } from './publicStyles';
import { PILOT_PATH } from './publicContent';

const NAV_LINKS = [
  { to: '/how-it-works', label: 'How it works' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/docs/benchmarks', label: 'Benchmarks' },
  { to: '/docs', label: 'Docs' },
];

export default function PublicNav() {
  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 50,
      background: 'rgba(6,13,24,0.92)', backdropFilter: 'blur(8px)',
      borderBottom: `1px solid ${C.border}`,
    }}>
      <div style={{
        maxWidth: 1080, margin: '0 auto', padding: '14px 24px',
        display: 'flex', alignItems: 'center', gap: 22, flexWrap: 'wrap',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <CrimsonLogo size={26} />
          <span style={{ color: C.text, fontWeight: 700, fontSize: 15 }}>
            CrimsonScan{' '}
            <span style={{ color: C.muted, fontWeight: 300, letterSpacing: 2 }}>SPECTRA</span>
          </span>
        </Link>
        <div style={{ flex: 1 }} />
        {NAV_LINKS.map(l => (
          <Link key={l.to} to={l.to} style={{ color: C.muted, fontSize: 14, textDecoration: 'none' }}>
            {l.label}
          </Link>
        ))}
        <Link to="/login" style={{ color: C.info, fontSize: 14, textDecoration: 'none' }}>Sign in</Link>
        <Link to={PILOT_PATH} style={{
          background: C.crimson, borderRadius: 6, color: '#fff',
          fontWeight: 600, fontSize: 13, padding: '8px 16px', textDecoration: 'none',
        }}>
          Request a pilot
        </Link>
      </div>
    </nav>
  );
}
